<div class="banner">
  <div class="container">
    <div class="row justify-content-between align-items-center">
      <div class="col-lg-6">
        <div
          class="header_left_text text-sm-left text-center"
          data-aos="fade-right"
        >
          You are invited by: {{ userName }}
        </div>
      </div>
      <div class="col-lg-6">
        <div class="header_left_text text-sm-right text-center">
          <!-- <a routerLink="/auth/login" class="sign_in_button" data-aos="fade-right">Sign In</a> -->
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="sign_up_button go"
            data-aos="fade-left"
            >Sign Up</a
          >
        </div>
      </div>
    </div>

    <div class="banner_mid">
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="row">
            <div class="col-md-6">
              <div class="banner_left_box">
                <h1>INTERNETS</h1>
                <h2 class="ml6">
                  <span class="text-wrapper">
                    <span class="letters">MOST POWERFUL</span>
                  </span>
                </h2>
                <h6 id="typedtext"></h6>
              </div>
            </div>
            <div class="col-md-6">
              <div class="banner_right_box">
                <h1>
                  <span class="text-wrapper">
                    <span class="letters"
                      >Welcome to our Extraordinary Global marketing
                      platform</span
                    >
                    <!--<span class="line"></span>-->
                  </span>
                </h1>
                <h4>Redefining automation with the Power of Internet!</h4>
                <p>
                  Experience the magic with our global marketing platform and
                  add wings to your existing business!
                </p>
                <!--<a href="#" class="become_button">Become A Founder Now</a>-->
              </div>
              <a
                [routerLink]="'.'"
                [queryParams]="{ reg: referralId }"
                [fragment]="'regform'"
                class="become_button"
                data-aos="zoom-in"
                ><span>Become A Founder Now </span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--SECTION TWO PART OPEN-->
<div class="sec_two">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="sec_two_left_box">
          <h1 data-aos="fade-right">EXPERIENCE AUTOPILOT EVERYTHING!</h1>
          <h6 data-aos="fade-left">
            HAVE A LOOK AT THE VIDEO TO GET AN INSIGHT OF OUR EXTRAORDINARY
            BUSINESS APPROACH.
          </h6>
          <p data-aos="fade-right">
            Step forward to experience the POWER of the INTERNET and the Concept
            of Working Online. AUTOPILOT EVERYTHING! YOU GET ONE LIFE - MAKE IT
            WORTH.
          </p>
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="become_button"
            ><span>Become A Founder Now </span></a
          >
        </div>
      </div>
      <div class="col-lg-6">
        <div class="sec_two_right_video" data-aos="zoom-in">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation15/images/sec_two_right_image.png"
            class="img-fluid"
            alt="image"
          />
          <div class="play_button">
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal1"
              ><img
                src="{{
                  myLinksS3URL
                }}frontend/presentation15/images/play_button.png"
                class="img-fluid"
                alt="image"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--SECTION TWO PART CLOSED-->

<!--SECTION THREE PART OPEN-->
<div class="sec_three">
  <div class="container">
    <div class="row d-flex">
      <div class="col-md-6 d-flex">
        <div class="sec_three_first_box" data-aos="fade-right">
          <h1>Join real people and get real results:</h1>
          <!--<ul>
                  <li>Infinite matrix</li>
<li>Automated payments</li>
<li>Automated traffics</li>
<li>Massive spillover</li>
                  </ul>-->
          <p>
            People from all over the world trusted our breakthrough platform and
            joined us to earn residual income for life! Over 577028+ founders
            have joined us already. We invite you to take a step forward to put
            your business on autopilot.
          </p>
          <!--<h6>People from all over the world trusted our breakthrough platform and joined us to earn residual income for life! Over 27000 founders have joined us already. We invite you to take a step forward to put your Business on autopilot.</h6>-->
        </div>
      </div>

      <div class="col-md-6 d-flex">
        <div class="sec_three_first_box" data-aos="fade-left">
          <h1>This breakthrough marketing solution promises to give you</h1>
          <p>
            Today where job opportunity is scanty and stability is not promised,
            people are working for long hours on less payment. Take a break and
            experience our extraordinary income design. A unique gift that will
            change your life for the better.
          </p>
          <ul>
            <li>No Requirements</li>
            <li>No Recruiting</li>
            <li>No Monthly Fees</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--SECTION THREE PART CLOSED-->

<div class="sec_four">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="sec_two_right_video" data-aos="zoom-in">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation15/images/sec_four_left_video.png"
            class="img-fluid"
            alt="image"
          />
          <div class="play_button_one">
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal2"
              ><img
                src="{{
                  myLinksS3URL
                }}frontend/presentation15/images/play_button.png"
                class="img-fluid"
                alt="image"
            /></a>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="sec_four_right_box">
          <p data-aos="fade-left">
            Still Using the Same Old, Broken Marketing Methods? Change for the
            better. Take Advantage of THIS NEW Technology! Watch the video and
            secure your position on O-Founders.
          </p>
          <h5 data-aos="fade-right">
            WHY GIVE AN EXCUSE, WHEN YOU CAN BE THE CHANGE? You can either.
          </h5>
          <div class="row">
            <div class="sec_four_first_box" data-aos="fade-left">
              <p>
                Wait for the business to launch and then select a package to
                become a founder if seats are available!
              </p>
            </div>
            <div class="sec_four_first_box" data-aos="fade-right">
              <p>
                Join now at a discounted price of $97 and join 1% top of others.
                This is highly recommended.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-sm-center">
        <div class="col-md-10">
          <div class="sec_four_bottom_box">
            <h2 data-aos="fade-up">
              I ACCEPTED THE SECOND OPTION. CHOOSE WISELY AND MAKE YOUR SMARTEST
              MOVE. YOU WILL BE GLAD OF THE REAL TIME RESULTS.
            </h2>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="become_button mx-auto"
              data-aos="zoom-in"
              ><span>Become A Founder Now </span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sec_five">
  <div class="row">
    <div class="col-lg-7">
      <div class="sec_five_left_box" data-aos="fade-right">
        <p>
          By now, the video must have given you a brief of our global business
          module. Mr. Mufareh’s strategies are a result of decades of experience
          and totally effective in helping you earn more.
        </p>
        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'regform'"
          class="become_button mx-auto"
          ><span>Become A Founder Now </span></a
        >
      </div>
    </div>
    <div class="col-lg-5">
      <div class="sec_two_right_video" data-aos="zoom-in">
        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation15/images/sec_five_right_video.png"
          class="img-fluid"
          alt="image"
        />
        <div class="play_button_two">
          <a
            href="#"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal3"
            ><img
              src="{{
                myLinksS3URL
              }}frontend/presentation15/images/play_button.png"
              class="img-fluid"
              alt="image"
          /></a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="sec_six">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 sec_six_left_box">
        <h1>REGISTER IN 3 EASY STEPS</h1>
        <div class="row">
          <div class="sec_six_left_first_box" data-aos="flip-up">
            <p>Fill up the basic form</p>
          </div>
          <div class="sec_six_left_first_box" data-aos="flip-right">
            <p>Choose a favorable mode and pay.</p>
          </div>
          <div class="sec_six_left_first_box" data-aos="flip-left">
            <p>Become a founder!</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 sec_six_right_box" data-aos="fade-left">
        <h1>WEBINAR</h1>
        <a
          href="#"
          class="webiner_button"
          data-toggle="modal"
          data-backdrop="static"
          data-keyboard="false"
          data-target="#previous"
          ><img
            src="{{ myLinksS3URL }}frontend/presentation15/images/play_icon.png"
            class="img-fliud"
            alt="image"
          />
          PREVIOUS WEBINAR PLAYBACK</a
        >
      </div>
    </div>

    <div class="row" id="regform">
      <div class="col-lg-7">
        <div
          class="form_box"
          data-aos="fade-up"
          id="reg_form"
          data-aos-duration="1500"
        >
          <div class="logo">
            <img
              src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
              class="img-fluid"
              alt="image"
            />
          </div>
          <h1>REGISTER</h1>

          <!-- <div class="alert-success">


                                        <strong>Success!</strong> 

                                    </div> -->

          <div class="panel-group cst">
            <form [formGroup]="registerForm">
              <div class="row reg">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      class="log_in_fild form-control"
                      placeholder="First Name"
                      formControlName="firstname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'required'
                        ) && registerForm.controls['firstname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      First Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Last Name"
                      class="log_in_fild form-control"
                      formControlName="lastname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'required'
                        ) && registerForm.controls['lastname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Last Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-block form-group">
                <input
                  matInput
                  type="text"
                  placeholder="Email Address"
                  class="log_in_fild form-control"
                  formControlName="email"
                  required
                />
                <span
                  *ngIf="
                    registerForm.controls['email'].hasError('required') &&
                    registerForm.controls['email'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Email id Required.
                </span>
                <span
                  *ngIf="registerForm.controls['email'].hasError('pattern')"
                  class="failed-validation"
                  style="color: red"
                >
                  Please enter valid email.
                </span>
                <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                 class="failed-validation" style="color: red">
                                  Email length sould be less than 100.
                                </span>-->
              </div>

              <div class="form-group d-block">
                <div class="password-block">
                  <input
                    matInput
                    placeholder="Password"
                    formControlName="password"
                    class="log_in_fild form-control"
                    [type]="pwdToggle ? 'text' : 'password'"
                    required
                  />
                  <button
                    type="button"
                    class="password-icon"
                    (click)="pwdToggle = !pwdToggle"
                  >
                    <i
                      class="fal"
                      [ngClass]="{
                        'fa-eye': pwdToggle,
                        'fa-eye-slash': !pwdToggle
                      }"
                    ></i>
                  </button>
                </div>
                <span
                  *ngIf="
                    registerForm.controls['password'].hasError('required') &&
                    registerForm.controls['password'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Password Required
                </span>
                <span
                  *ngIf="registerForm.controls['password'].hasError('pattern')"
                  class="failed-validation"
                  style="color: red"
                >
                  Password should contain minimum 8 Characters and Atleast one
                  Uppercase, One Lowercase, one Number and one Special
                  Characters
                </span>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Phone Number"
                      class="log_in_fild form-control"
                      formControlName="phone"
                      onKeyPress="if(this.value.length==20) return false;"
                      onkeydown="return event.keyCode !== 69"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('required') &&
                        registerForm.controls['phone'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Phone number is required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['phone'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('minlength') ||
                        registerForm.controls['phone'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 6 and max 20 digits.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <select
                      formControlName="country_id"
                      required
                      class="log_in_fild form-control"
                    >
                      <option value="">Select Country</option>
                      <option
                        *ngFor="let country of countriesList"
                        [value]="country.countryId"
                      >
                        {{ country.countryName }}
                      </option>
                    </select>
                    <span
                      *ngIf="
                        registerForm.controls['country_id'].hasError(
                          'required'
                        ) && registerForm.controls['country_id'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Plese Select Country
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <div class="row no-gutters">
                                                <div class="capcha form-control">
                                                    <img [src]="imageCaptcha" style="width: 120px" />
                                                </div>

                                                <div class="refresh-icn">
                                                    <i class="fa fa-refresh fa-lg" aria-hidden="true" (click)="regenerateCaptcha()"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <div class="main input-effect">
                                                <input id="capcha" maxlength="5" name="capcha" type="text" formControlName="enteredCaptcha" placeholder=" Enter Captcha" class="form-control effect-19" required="required" />
                                                <span *ngIf="
                          registerForm.controls['enteredCaptcha'].hasError(
                            'required'
                          ) && registerForm.controls['enteredCaptcha'].touched
                        " class="failed-validation" style="color: red">
                        Captcha Required
                      </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
              <div class="text-center">
                <button
                  mat-raised-button
                  type="submit"
                  (click)="submitRegister()"
                  [disabled]="registerForm.invalid"
                  class="ibtn w-100"
                >
                  SignUp
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-5" data-aos="fade-up" data-aos-duration="1500">
        <div class="sec_six_right_box_bottom">
          <h2>WELCOME</h2>
          <h1>O-Founders</h1>
          <P
            >Our magical platform will help every individual from around the
            globe succeed. Yes, your problems are over! Just have a little bit
            more patience and it will come to you in the very near future.
            Meanwhile, get yourself ready for the global launch and the
            time-of-your-life. You owe this to your family and yourself. The
            business is DONE-FOR-YOU, including all of those people who cannot
            or will not recruit on their own.
          </P>
          <a
            routerLink="/auth/login"
            class="become_button mx-auto"
            target="_blank"
            rel="noopener"
            ><span>Sign In</span></a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="testimonials_sec">
  <div class="container">
    <div class="row">
      <!--TESTIMONIALS PART OPEN-->

      <div class="testimonial-container">
        <div class="dk-container">
          <div class="cd-testimonials-wrapper cd-container">
            <div class="cd-testimonials">
              <ngx-slick-carousel
                class="carousel"
                #slickModal="slick-carousel"
                [config]="slideConfig"
                (init)="slickInit($event)"
              >
                <div ngxSlickItem class="testimonial-content">
                  <h2>An ideal model for anyone</h2>
                  <p>
                    His drive and passion for creating a platform to help
                    everyone from seasoned marketers to the "little guy" helped
                    solidify my belief Then learning how we benefit financially
                    with optional starting points, makes this an ideal model for
                    anyone with a business who needs advertising.
                  </p>

                  <p>
                    Thank you Ash for your vision and help for so many people
                    around the world.
                  </p>

                  <div class="cd-author">
                    <img
                      src="{{ cloudFrontUrl }}uploads/t1.png"
                      alt="Author image"
                    />

                    <ul class="cd-author-info">
                      <li>Tim <strong>Leach</strong></li>

                      <li></li>
                    </ul>
                  </div>
                </div>

                <div ngxSlickItem class="testimonial-content">
                  <h2>This Will Undoubtedly Change Your Life!</h2>
                  <p>
                    I want to personally say thank you to everyone on this
                    awesome journey that Ash Murareh has created. As many of you
                    may not know, Ash is a very successful online marketer and
                    has made his living in this industry building massive teams
                    for various companies. He saw a big need for creating a
                    company that would help the average person succeed online so
                    he decided to build it himself.
                  </p>

                  <p>
                    When you listen to his Founder's presentations or when you
                    speak with him, you will immediately feel his passion to
                    build a highly effective business where every single person
                    will be successful.
                  </p>

                  <div class="cd-author">
                    <img
                      src="{{ cloudFrontUrl }}uploads/t4.png"
                      alt="Author image"
                    />

                    <ul class="cd-author-info">
                      <li>Mike <strong>Williams</strong></li>

                      <li></li>
                    </ul>
                  </div>
                </div>

                <div ngxSlickItem class="testimonial-content">
                  <h2>
                    I am totally blown away and will build my final dynasty here
                    in ONPASSIVE
                  </h2>
                  <p>
                    In my 19 years successful career in this space,I have never
                    seen a business so full, so disruptive, so intriguing that
                    everyone I approach is excited to belong.
                  </p>

                  <p>
                    Did a Facebook post, alongside my WhatsApp campaign, on the
                    founder position, that attracted 122 comments, 14 people
                    have joined direct to me and in less than 48 hours, 59 super
                    qualified leads have submitted their email, requesting
                    information to be founders, AND ALL THESE WITHOUT ANYTHING
                    YET ONGROUND, not even a website. I am totally blown away
                    and will build my final dynasty here in ONPASSIVE.
                  </p>

                  <div class="cd-author">
                    <img
                      src="{{ cloudFrontUrl }}uploads/t2.png"
                      alt="Author image"
                    />

                    <ul class="cd-author-info">
                      <li>PRINCE <strong>OBI</strong></li>

                      <li></li>
                    </ul>
                  </div>
                </div>
              </ngx-slick-carousel>
            </div>
          </div>

          <!-- cd-testimonials -->
        </div>
      </div>

      <!--TESTIMONIALS PART CLOSED-->
    </div>
  </div>
</div>
<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h6>FOR A LITTLE WHILE YET, FOUNDER POSITIONS STILL AVAILABLE!</h6>
        <p>COPYRIGHT O-Founders 2022</p>
      </div>
    </div>
  </div>
</div>

<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video1
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="second_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video2
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="third_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video3.pause(); video3.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video3
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="previous" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          id="prev_video_pause"
          (click)="video4.pause(); video4.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video4
        width="100%"
        class="video-js"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}videos/title.jpg"
        id="my-video"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          id="video"
          type="video/mp4"
        />

        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</div>
